interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

const buildPages = (current: number, total: number): (number | '...')[] => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | '...')[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
};

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  return (
    <nav className="mt-8 flex items-center justify-center gap-2 flex-wrap" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1 hover:border-primary-300 hover:text-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        上一页
      </button>

      {buildPages(current, total).map((p, idx) =>
        p === '...' ? (
          <span key={`ellipsis-${idx}`} className="px-1 text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-9 min-w-9 px-2 rounded-md text-sm transition-colors cursor-pointer ${
              p === current
                ? 'bg-primary-600 text-background-50 font-medium'
                : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
            }`}
            aria-current={p === current ? 'page' : undefined}
          >
            {p}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1 hover:border-primary-300 hover:text-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </nav>
  );
}